<template>
	<div>
		<div>
			<v-row>
				<v-col cols="12" md="3" >
					<v-card elevation="4" class="rounded-lg">
						<v-card-title class="grey " style="padding: 1%;">
							<span style="color: #f1f1f1; margin-left: 15px;">Proyectos</span>
							<v-btn
								icon
								@click="opendialogResult"
								color="white"
							>
								<v-icon>mdi-chart-bar</v-icon>
							</v-btn>
							<v-btn
								icon
								@click="opendialogTaskProceso"
								color="white"
								v-if="$fun.isAdmin()"
							>
								<v-icon>mdi-circle-edit-outline</v-icon>
							</v-btn>
						</v-card-title>
						<!-- Filtros -->
						<v-card-text class="pb-0 pl-0 pr-0">
							<v-chip-group 
								v-model="selectedFilter" 
								mandatory 
								show-arrows
								center-active
								class="px-4 pl-1 pr-1"
							>
								<v-chip 
									small
									v-for="filter in filters" 
									:key="filter.value"
									:value="filter.value"
									variant="flat"
									:color="selectedFilter === filter.value ? 'primary' : 'default'"
									@click="filterProjects(filter.value)"
								>
									{{ filter.label }}
								</v-chip>
							</v-chip-group>
						</v-card-text>
						<v-list   
							:lines="false"
							density="compact"
							nav
							dense
							class="scrollable">
							<v-list-item-group>
								<v-list-item v-for="project in Proyectic" 
								:key="project.TkpID" 
								@click="clickProyect(project)"
								color="info">
									<v-list-item-icon>
										<v-icon>mdi-laptop</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>{{ project.TkpTitle }}</v-list-item-title>
									</v-list-item-content>
									<v-chip x-small color="success" v-if="project.TypeNivelUsr == 1">
										{{ project.TypeNivelUsrName }}
									</v-chip>

								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card>
				</v-col>
		        <v-col cols="12" md="9">
				<s-crud
					v-if="dialogTable"
					:title="proyect.TkpTitle"
					:config="config"
					:filter="filter"
					:add="TkpStatus == 3 ? false : true"
					:edit="TkpStatus == 3 ? false : true"
					:remove="TkpStatus == 3 ? false : true"
					@save="save($event)"
					ref="gridtask"
					@rowSelected="rowSelected($event)" 
					searchInput
				>
					<template v-slot:filter>
					<v-container>
						<v-row>
							<v-col v-if="filter.IsAdmin == 1">
								<s-select-assigned
									:projectID="filter.TkpID"
									full
									return-object
									label="Responsable"
									clearable
									v-model="filter.PrsID"
								></s-select-assigned>
							</v-col>
							<v-col>
								<s-select-definition
									label="Prioridad"
									:def="1392"
									v-model="filter.TskPriority"
									clearable
								></s-select-definition>
							</v-col>
							<v-col>
								<s-select-definition
									label="Estado"
									:def="1393"
									v-model="filter.TskStatus"
									clearable
								></s-select-definition>
							</v-col>
							<v-col cols="3">
								<s-select-definition
									label="Tipo Tarea"
									:def="1476"
									v-model="filter.TypeTask"
									clearable
								></s-select-definition>
							</v-col>
							<v-col>
								<s-select-definition
									label="Clasificación"
									:def="1528"
									v-model="filter.TypeClasification"
									clearable
								></s-select-definition>
							</v-col>
						</v-row>
					</v-container>
					</template>

					<template v-slot:AsgWorkerName="{ row }">
						<v-btn v-if="$fun.isAdmin()" x-small color="primary" @click="AsgWorkerName(row)">
							<i class="fas fa-plus-circle"></i>
						</v-btn>
					</template>

					<template scope="props">
						<v-container>
							<v-row >
								<v-col cols="12">
									<div>
										<s-text
											label="Titulo"
											v-model="props.item.TskTitle"
										></s-text>
									</div>
								</v-col>
								
								<v-col cols="12">
									<div>
										<s-textarea
											label="Descripción"
											v-model="props.item.TskDescription"
										></s-textarea>
									</div>
								</v-col>

								<v-col cols="4">
									<div>
										<s-select-definition
											label="Clasificación"
											:def="1528"
											v-model="props.item.TypeClasification"
										></s-select-definition>
									</div>
								</v-col>
								
								<v-col lg="4" v-show="props.item.TypeClasification == 2">
									<div v-if="props.item.TypeClasification == 2">
										<v-file-input
											label="Anexo"
											v-model="Attach1"
											hide-details
										/>
									</div>
								</v-col>
								
								<v-col cols="4" v-show="props.item.TypeClasification !== 2">
									<div v-if="props.item.TypeClasification !== 2">
										<s-select-definition
											label="Prioridad"
											:def="1392"
											v-model="props.item.TskPriority"
										></s-select-definition>
									</div>
								</v-col>
								
								<v-col cols="4" v-show="props.item.TypeClasification !== 2">
									<div v-if="props.item.TypeClasification !== 2">
										<s-select-definition
											label="Tipo Tarea"
											:def="1476"
											v-model="props.item.TypeTask"
										></s-select-definition>
									</div>
								</v-col>
								
								<v-col cols="6" v-show="$fun.isAdmin() && props.item.TypeClasification !== 2">
									<div>
											<s-select-assigned
											:projectID="proyect.TkpID"
											full
											return-object
											label="Asignado a"
											clearable
											v-model="props.item.PrsID"
										></s-select-assigned>
									</div>
								</v-col>
								
							</v-row>
						</v-container>
					</template>

					<template v-slot:FilePathDownload="{ row }">
						<v-btn v-if="row.FilePath != null && row.TypeClasification == 2" color="success" class="mt-5" :disabled=false icon x-small @click='openFile(row.FilePath)'> <v-icon>mdi-download</v-icon>  </v-btn>
					</template>

					<template v-slot:Action="{ row }">
						<v-btn
							v-if="row.TskStatus == 1"
							x-small
							dark
							color="success"
							elevation="1"
							class="text-none"
							@click="clickActionTask(row)"
						>
							<v-icon left small>mdi-play</v-icon>
							{{'Iniciar'}}
						</v-btn>
						<v-btn
							v-if="row.TskStatus == 2 && row.TskPaused == 0"
							x-small
							dark
							color="red"
							elevation="2"
							class="text-none"
							@click="clickActionTask(row)"
						>
							<v-icon left small>mdi-stop</v-icon>
							{{'Terminar'}}
						</v-btn>
					</template>

					<template v-slot:TskPause="{ row }">
						<v-btn
							v-if="row.TskStatus != 1 && row.TskStatus != 3"
							x-small
							dark
							depressed
							:color="row.TskPaused == 1 ? '#1DE9B6' : '#FF9100'"
							@click="clickPausedTask(row)"
						>
							<v-icon>{{ row.TskPaused == 1 ? 'mdi-play-circle-outline' : 'mdi-pause-circle-outline' }}</v-icon>
						</v-btn>
					</template>
					
					<template v-slot:ConditButt="{ row }" v-if="$fun.isAdmin()">
						<v-btn
							x-small
							color="info"
							@click="clickConditionTask(row)"
						>
							<v-icon>mdi-information</v-icon>
						</v-btn>
					</template>

					<template v-slot:TskStatus="{ row }">
						<v-chip 
							x-small 
							black
							:color="row.TskStatusColor"
							style="color: white;"
						>
							{{ row.TskStatusName }}
						</v-chip>
					</template>
					
					<template v-slot:NameTypeTask="{ row }">
						<v-chip 
							x-small 
							black
							:color="row.TypeTask ===1 ? '#abd5f5' : '#fdeb65'"
						>
							{{ row.NameTypeTask }}
						</v-chip>
					</template>

					<template v-slot:TskPriority="{ row }">
						<v-chip 
							x-small 
							black
							:color="row.TskPriorityColor"
						>
							{{ row.TskPriorityName }}
						</v-chip>
					</template>

					<template v-slot:TskMultiple="{ row }">
						<v-menu
							:close-on-content-click="false"
							:nudge-width="200"
							offset-y
							transition="slide-x-reverse-transition"
						>
							<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								icon
								x-small
								color="primary"
								aria-label="Opciones de tarea"
							>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
							</template>
							<v-card>
							<v-list dense>
								<v-list-item @click="clickActionTask(row)" aria-label="Iniciar" v-if="row.TskStatus == 1">
									<v-list-item-icon>
										<v-icon>mdi-play</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Iniciar</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="clickActionTask(row)" aria-label="Finalizar" v-if="row.TskStatus == 2 && row.TskPaused == 0">
									<v-list-item-icon>
										<v-icon>mdi-stop</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Finalizar</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="clickPausedTask(row)" aria-label="" v-if="row.TskStatus != 1 && row.TskStatus != 3">
									<v-list-item-icon>
										<v-icon>{{ row.TskPaused == 1 ? 'mdi-play-circle-outline' : 'mdi-pause-circle-outline' }}</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>{{ row.TskPaused == 1 ? 'Reanudar' : 'Pausar' }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="clickConditionTask(row)" aria-label="Ver condición de tarea" v-if="$fun.isAdmin()">
									<v-list-item-icon>
										<v-icon>mdi-information-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Ver condición</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="AsgWorkerName(row)" aria-label="Asignar trabajador" v-if="$fun.isAdmin()">
									<v-list-item-icon>
										<v-icon>mdi-account-plus-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Asignar a trabajador</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="TskHistory(row)" aria-label="Ver Historial">
									<v-list-item-icon>
										<v-icon>mdi-eye-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Ver Historial</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="TskTransfer(row)" aria-label="Ver Historial">
									<v-list-item-icon>
										<v-icon>mdi-folder-move-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Mover actividad</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
							</v-card>
						</v-menu>
					</template>

			 	</s-crud>
			 	</v-col>
		    </v-row>
		</div>

		<v-dialog
		v-model="dialogResult" 
		max-width="600px" persistent
		>
		<v-card>
			<!-- <v-card-title class="result-title">
			RESUMEN POR SEMANA
			</v-card-title> -->
			<s-toolbar label="RESUMEN POR SEMANA" dark color="#8e8f91"  excel @excel="downloadExcel()"></s-toolbar>
			<v-card-text>
			<v-col style="padding-top:0px;">
					<v-row justify="center">
						<v-col lg="3"  style="padding-bottom:0px">
							<s-select label="Año" :items="years" outlined hide-details dense v-model="year"></s-select>
						</v-col>
						<v-col lg="3" style="padding-bottom:0px">
							<!--  <s-select label="Periodo" dense hide-details outlined :items="itemsWeek" v-model="week"></s-select>-->
							<s-select small-chips attach="" multiple label="N° Semana" dense hide-details outlined :items="itemsWeek"  v-model="week"></s-select>
						</v-col>
						<v-col lg=3>
						<s-date label="Fecha Inicio" v-model='BeginDate'
						/>  </v-col>
						<v-col lg=3> 
						<s-date label="Fecha Fin" v-model='EndDate'
					>
							
						</s-date>  </v-col>
					</v-row>
			</v-col>
					<!-- Fila de cabecera adicional -->
			<v-row>
				<v-col v-for="(item, index) in headerRow" :key="index" class="text-center" style="margin-top: 10px; background-color: #e7eef1;">
					<span >{{ item }}</span>
				</v-col>
			</v-row>

				<!-- Tabla de datos -->
			<v-row>
				<v-col class="pl-0 pt-0 pb-0 pr-0">
					<v-data-table
						:headers="headerProductionGroup"
						:items="summarytic"
						hide-default-footer
						disable-sort
						:loading="loadingData"
					>
					<template v-slot:item.ProgramadaTo="{ item }"> 
						<v-chip
							small
							dark 
							:color="'success'"
						>
							{{ item.ProgramadaTo }}
						</v-chip>
					</template>
					<template v-slot:item.NoProgramadaTo="{ item }"> 
						<v-chip
							small
							dark 
							:color="'info'"
						>
							{{ item.NoProgramadaTo }}
						</v-chip>
					</template>
					</v-data-table>
				</v-col>
			</v-row>
			</v-card-text>
			<v-card-actions>
				<v-btn	v-btn color="primary" @click="dialogResult = false; week=null;">Cerrar</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>

		<v-dialog v-model="dialogProccess" max-width="800px" persistent>
			<v-card>
				<v-card-title class="result-title">
					<s-toolbar
						label="TAREAS ACTIVAS EN PROCESO"
						dark
						color="#3f51b5"
						close
						@close="dialogProccess = false; week=null;"
					></s-toolbar>
				</v-card-title>
				<v-card-text>
					<v-data-table
						item-key="TskID"
						:headers="headerTasksProcess"
						:items="tictaStatusList"
						v-model="selectedtictaStatus"
						:items-per-page="10"
						dense
					>
						<template v-slot:[`item.TskDate`]="{ item }">
							{{ $fun.formatDateTimeView(item.TskDate) }}
						</template>
						<template v-slot:[`item.TskStatusList`]="{ item }">
							<v-chip 
								x-small 
								black
								:color="item.TskStatusColor"
								style="color: white;"
							>
								{{ item.TskStatusName }}
							</v-chip>
						</template>
					</v-data-table>

				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-if="modalCondition" v-model="modalCondition" max-width="600px">
			<Task-Condition :item="newData" @close="close"></Task-Condition>
		</v-dialog>

		<v-dialog
			v-model="dialogUsers"
			width="500"
			persistent
		>
		<v-card>
			<v-card-title>
			<s-crud 
                add
                edit
                @save="saveTaskUser($event)"
                height="auto" 
                remove
                title="Usuarios"
				:filter="filterUser"
                :config="configSearch"
                searchInput
                close
                @close="dialogUsers=false"
                ref = "ScrudTaskUsers"
            >

				<template scope="props">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<s-select-assigned
								:projectID="itemSelectedSave.TkpID"
								full
								return-object
								label="Responsable"
								clearable
								v-model="props.item.PrsID"
							></s-select-assigned>
						</v-col>
					</v-row>
				</template>

            </s-crud>
			</v-card-title>
		</v-card>
		</v-dialog>

		<v-dialog
			v-model="dialogUsersAdd"
			width="500"
			persistent
		>
		<v-card>
			<v-container style="padding: 5px 15px 5px 5px;">
				<s-user v-model="usersCopy" ref="usrcopy" :isCrud="false" :singleRow="false" />
				<v-row>
					<v-col>
						<v-btn color="red" dark depressed small @click="dialogUsersAdd=false">Cancelar</v-btn>
					</v-col>
					<v-col align="right">
						<v-btn color="success" dark depressed small @click="saveUserPermit()">Asignar Usuarios</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
		</v-dialog>

		<v-dialog
			v-model="OpenHistory"
			width="600"
			persistent
			v-if="OpenHistory"
		>
			<TaskHistory :item="dataHistory" @close="OpenHistory = false"></TaskHistory>
		</v-dialog>

		<v-dialog v-model="transferDialog" max-width="800px" persistent>
			<v-card class="rounded-xl elevation-8">
				<!-- Encabezado del diálogo -->
				<v-toolbar color="primary" dark flat>
				<v-icon left>mdi-folder-move-outline</v-icon>
				<span class="title font-weight-medium">Transferir tarea</span>
				</v-toolbar>

				<!-- Subtítulo -->
				<v-card-subtitle class="py-2 px-4" v-if="selectedTask">
				<v-icon small class="mr-1">mdi-clipboard-list-outline</v-icon>
				Tarea: <strong>{{ selectedTask.TskTitle }}</strong>
				</v-card-subtitle>

				<!-- Contenido -->
				<v-card-text class="pa-4">
				<v-row dense>
					<!-- Columna izquierda: lista de proyectos -->
					<v-col cols="6">
					<h4 class="subtitle-1 mb-2 font-weight-medium">Seleccionar proyecto destino:</h4>
					<v-list two-line dense class="scrollable white--bg rounded-lg elevation-1" style="max-height: 300px; overflow-y: auto;">
						<v-list-item-group v-model="selectedProjectIndex" color="primary">
						<v-list-item
							v-for="(project, index) in availableProjects"
							:key="project.TkpID"
							:disabled="project.TkpID === currentProjectId"
							class="hoverable"
						>
							<!-- Icono pequeño -->
							<v-list-item-avatar size="24">
							<v-icon small color="primary">mdi-laptop</v-icon>
							</v-list-item-avatar>

							<!-- Título -->
							<v-list-item-content>
							<v-list-item-title class="text-truncate">{{ project.TkpTitle }}</v-list-item-title>
							</v-list-item-content>

							<!-- Chip del tipo solo si aplica -->
							<v-list-item-action v-if="project.TypeNivelUsr == 1">
							<v-chip small color="green lighten-2" text-color="white">
								{{ project.TypeNivelUsrName }}
							</v-chip>
							</v-list-item-action>

							<!-- Indicador de proyecto actual -->
							<v-list-item-action v-else-if="project.TkpID === currentProjectId">
							<v-chip small outlined color="primary">Actual</v-chip>
							</v-list-item-action>
						</v-list-item>
						</v-list-item-group>
					</v-list>
					</v-col>

					<!-- Columna derecha: motivo del traslado -->
					<v-col cols="6">
					<h4 class="subtitle-1 mb-2 font-weight-medium">Motivo del traslado:</h4>
					<v-textarea
						v-model="transferReason"
						placeholder="Escribe aquí el motivo"
						outlined
						auto-grow
						dense
						counter="100"
					></v-textarea>
					</v-col>
				</v-row>
				</v-card-text>

				<!-- Acciones -->
				<v-card-actions class="pa-3 grey lighten-4">
				<v-spacer></v-spacer>
				<v-btn text color="grey darken-1" @click="cancelTransfer" class="font-weight-medium">
					Cancelar
				</v-btn>
				<v-btn
					color="primary"
					class="elevation-2 font-weight-medium"
					@click="confirmTransfer"
					:disabled="selectedProjectIndex == null"
					:loading="transferring"
				>
					<v-icon left>mdi-folder-move</v-icon>
					Transferir
				</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


	    </div>
</template>

<style scoped>

	.result-title {
	background-color: #3f51b5; 
	color: white;
	padding: 16px 24px;        
	font-weight: bold;        
	border-bottom: 2px solid #fff; 
	border-radius: 4px 4px 0 0;
	margin-bottom: 15px;
	}

	.rounded-xl {
	border-radius: 16px !important;
	}

	.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.03);
	cursor: pointer;
	}

	.white--bg {
	background-color: white;
	}

	.elevation-1 {
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.04); /* efecto hover suave */
	cursor: pointer;
	}

	.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 70%; /* que quepa el chip a la derecha */
	}
</style>
<script>
	import _sTaskService from '@/services/Utility/TaskService.js';
	import _sTaskUsersService from '@/services/Utility/TaskUsersService.js';
	import sTextarea from '../../../components/Utils/sTextarea.vue';
	import sSelectAssigned from '../../../components/Utils/SSelectAssigned.vue';
	import { isUndefined } from 'lodash';
	import _sGeneral from "@/services/HelperService.js";
	import _sHelper from "@/services/HelperService";
	import sUser from "@/views/Security/UserOption/User.vue";
	import _sDefinition from "@/services/General/DefinitionService.js";
	import TaskHistory from './TaskHistory.vue';
	import TaskCondition from './TaskCondition.vue';

	export default {
    components: { sTextarea, sUser, sSelectAssigned, TaskHistory, TaskCondition },
		data() {
			return {
				loadingData: false,
				usersCopy: [],
				dialogUsers: false,
				dialogUsersAdd: false,
				Attach1: null,
				dialogTable: true,
				TkpStatus: null,
				TkcID: 0,
				proyect: {},
				datatransfer: {},
				dataPaused: {},
				dialogTransfer: false,
				dialogPaused: false,
				dialogResult: false,
				selected : {},
				workerstic: [],
				targetTic:[],
				ConditionTic:[],
				summarytic:[],
				Gensummarytic:[],
				Proyectic:[],
				itemsWeek: [],
				years: [],
				dialogProccess:false,
				TksIDi:0,
				modalCondition:false,
				year: null,
				week: null,
				month:null,
				SecStatus:1,
				year:null,
				BeginDate:null,
				EndDate:null,
				tictaStatusList: [],
				selectedtictaStatus : [],
				OpenHistory:false,
				dataHistory:{},
				filter: {
					PrsID: 0,
					IsAdmin: this.$fun.isAdmin() ? 1 : 0	,
					TkpID:0,
					TypeClasification : null 
				},
				filterUser : {
					TskID: 0
				},
				page: 1, // Página actual
				perPage: 10, // Elementos por página
				filterText: '', // Texto de filtro
				showInputField:false,
				newConditionName:'',
				configSearch: {
					model: {
						PrsID: "ID",
						NtpFullName: "NtpFullName"
					},
					service: _sTaskUsersService,
					headers: [
						{text: "ID", value: "PrsID"},
						{text: "Apellidos y Nombres", value: "NtpFullName"}
					]
				},
				itemsSearch: [],
				selectedSearch: [],

				config: {
					model: {
						TskID: "ID",
						Action: "Action",
						ConditButt: "ConditButt",
						TskStatus: "integer",
						TskPriority: "integer",
						NameTypeTask: "integer",
						FilePathDownload: "FilePathDownload",
						AsgWorkerName: ""
					},
					service: _sTaskService,
					headers: [
						{text: "Opciones", value: "TskMultiple"},
						{text: "ID", value: "TskID"},
						
						{text: "Estado", value: "TskStatus"},
						{text: "Titulo", value: "TskTitle"},
						{text: "Tipo", value: "TypeClasificationName"},
						{text: "Archivo", value: "FilePathDownload"},
						// {text: "Objetivo", value: "TargetName"},
						{text: "Prioridad", value: "TskPriority"},
						{text: "Abierto", value: "TskDateName"},
						{text: "Tipo Tarea", value: "NameTypeTask"},
						
						// { text: "F. Ini", value: "TskDateBeginName" },
						// { text: "F. Fin", value: "TskDateEndName" }
						
					]
				},
				headerRow: ['', 'PROGRAMADO', 'NO PROGRAMADO'],
				headerProductionGroup: [
					{ text: "Nombre", value: "WorkerName" }, 
					{ text: "Total", value: "ProgramadaTo" },
					{ text: "Pendiente", value: "ProgramadaPen" },
					{ text: "Finalizado", value: "ProgramadaFin" }, 
					{ text: "Total", value: "NoProgramadaTo" , headerClass: 'success', },
					{ text: "Pendiente", value: "NoProgramadaPen" , headerClass: 'success', },
					{ text: "Finalizado", value: "NoProgramadaFin" , headerClass: 'success', }

				],
				headerTasksProcess : [
					{ text: "ID", value: "TskID" },
					{ text: "Titulo", value: "TskTitle" },
					{ text: "Descripción", value: "TskDescription" },
					{ text: "Responsable", value: "WorkerName" },
					{ text: "Cargo", value: "PstName" },
					{ text: "Proyecto", value: "TkpTitle" },
					{ text: "Fecha Creación", value: "TskDate" },
					{ text: "Estado", value: "TskStatusList" },
				],
				itemSelectedSave: {},
				selectedFilter: 2,
				filters: [],
				newData: {},
				transferDialog: false,
				selectedTask: null,
				selectedProjectIndex: null,
				availableProjects: [],
				currentProjectId: null,
				transferring: false
			}
		},
		computed: {
			filtereditemsSearch() {
				return this.itemsSearch.filter(item => item.SecStatus !== 0);
			},
			filteredConditions() {
				// Filtramos las condiciones según el texto de búsqueda
				const filtered = this.ConditionTic.filter(condition =>
				condition.TkcName.toLowerCase().includes(this.filterText.toLowerCase())
				);
				return filtered.slice((this.page - 1) * this.perPage, this.page * this.perPage);
			},
			totalPages() {
				// Calculamos cuántas páginas serán necesarias
				const filteredCount = this.ConditionTic.filter(condition =>
				condition.TkcName.toLowerCase().includes(this.filterText.toLowerCase())
				).length;
				return Math.ceil(filteredCount / this.perPage);
			},
			progressPercentage() {
				// Filtramos las condiciones visibles
				const totalVisibleConditions = this.filteredConditions.length;
				const selectedConditions = this.filteredConditions.filter(condition => condition.selected).length;

				// Si no hay condiciones visibles, no hay progreso
				if (totalVisibleConditions === 0) return 0;

				// Calculamos el porcentaje
				return (selectedConditions / totalVisibleConditions) * 100;
			},
			selectedProject() {
				if (this.selectedProjectIndex !== null && this.selectedProjectIndex !== undefined) {
					return this.availableProjects[this.selectedProjectIndex];
				}
				return null;
			}
		},
		watch : {
			filter(){
				console.log(this.filter)
			},
			week(){
				if (this.week == 1) {

				this.BeginDate = this.$moment(this.year+'0101').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY-MM-DD');
				this.EndDate = this.$moment(this.year+'0101').isoWeek(this.itemsWeek[0]).endOf("isoweek").format('YYYY-MM-DD');

				if(this.year!=this.$moment(this.year+'0101').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY')){
					this.BeginDate=this.$moment(this.year+'0108').isoWeek(this.itemsWeek[0]).startOf("isoweek").format('YYYY-MM-DD');
					this.EndDate = this.$moment(this.year+'0108').isoWeek(this.itemsWeek[0]).endOf("isoweek").format('YYYY-MM-DD');

				}
				} 
				else if (this.week > 1) {
				// console.log("this.itemsWeek[this.itemsWeek.length - 1]", this.itemsWeek[this.itemsWeek.length - 1])
				// console.log("this.itemsWeek[0]", this.itemsWeek[0])
				if (this.itemsWeek[this.itemsWeek.length - 1].value > this.itemsWeek[0].value) {
					
					// console.log("1 if")
					// let min = Math.min(...this.itemsWeek);
					let min = this.week;
				// console.log("  min[0]", min)

					this.BeginDate = this.$moment(this.year+'0101').isoWeek(min).startOf("isoweek").format('YYYY-MM-DD');
					this.EndDate = this.$moment(this.year+'0101').isoWeek(min).endOf("isoweek").format('YYYY-MM-DD');
				
				} else {
					// console.log("2 if")
					let max = Math.max(...this.itemsWeek);

					this.BeginDate = this.$moment(this.year+'0101').isoWeek(this.itemsWeek[this.itemsWeek.length - 1]).startOf("isoweek").format('YYYY-MM-DD');
					this.EndDate = this.$moment(this.year+'0101').isoWeek(max).endOf("isoweek").format('YYYY-MM-DD');
						
					if(this.year!=this.BeginDate.year){
						this.BeginDate=this.$moment(this.year+'0108').isoWeek(this.itemsWeek[this.itemsWeek.length - 1]).startOf("isoweek").format('YYYY-MM-DD');
						this.EndDate = this.$moment(this.year+'0108').isoWeek(max).endOf("isoweek").format('YYYY-MM-DD');

					}
				}

				if (this.week.length > 1) {

					if ((this.week.find((x) => { return x == (this.week[this.week.length - 1] - 1) }) == null) &&
						(this.week.find((x) => { return x == (this.week[this.week.length - 1] + 1) }) == null)) {
						this.week = this.week.filter((x) => { return x != this.week[this.week.length - 1] })
					}
				}
				}
				else{
				this.EndDate = this.$moment().add('days', -1).format("YYYY-MM-DD");
				this.BeginDate = this.$moment().format("YYYY-MM-DD");
				}
				this.getTicSummary();
				this.getTicGeneralSummary();
			},
			BeginDate(){
				this.getTicSummary();
				this.getTicGeneralSummary();
			},
			EndDate(){
				this.getTicSummary();
				this.getTicGeneralSummary();
			},
		},
		methods: {
			filterProjects(filter) {
				this.selectedFilter = filter;
				// Aquí implementa la lógica de filtrado de proyectos
				this.getTicProyects();
			},
			loadDefinition () {
				_sDefinition.definitiongroup(1393, 0, this.$fun.getUserID()).then((r) => {
					this.filters = r.data.map(item => ({
						label: item.DedDescription,
						value: item.DedValue,
						helper: item.DedHelper
					}));
				});
			},
			selectCondition(condition) {
				console.log("selectcondi",condition);
				this.TkcID=condition.TkcID;
				this.showInputField = true;
				this.newConditionName=condition.TkcName ;
			},
			FunctDelete(condition){
				this.TkcID=condition.TkcID;
				this.newConditionName=condition.TkcName ;
				this.SecStatus = 0;
				this.registrarCondicion();
			},
			AsgDeleteSchedule(){
				// console.log("this.selectedSearch:",this.selectedSearch);
				if(this.selectedSearch[0].TtuID == null){
					this.itemsSearch.splice(this.itemsSearch.indexOf(this.selectedSearch[0]), 1);
				}else{
					// console.log("this.selectedSearchRemove:",this.selectedSearch[0]);
					const index = this.itemsSearch.indexOf(this.selectedSearch[0]);
					if (index !== -1) {
						this.itemsSearch[index].SecStatus = 0;
					}
				}

				this.selectedSearch = [];
			},
			saveUsers(){
				// console.log("saveUsers:",this.itemsSearch);
				this.itemSelectedSave.itemsDetail = this.itemsSearch;
				this.itemSelectedSave.UsrUpdateID = this.$fun.getUserID();
				// console.log("itemSelectedSave:",this.itemSelectedSave);
				_sTaskService.save(this.itemSelectedSave, this.$fun.getUserID())
				.then(resp => {
					// console.log("resp:",resp);
					if(resp.status == 200){
						this.$fun.alert("Actualizado correctamente", "success");
						this.$refs.gridtask.refresh();
						this.dialogUsers = false;
					}
				})
			},
			saveUserPermit(){
				this.usersCopy = Object.assign([], this.usersCopy).filter((x) => x.UsrID != "");
				// console.log("this.usersCopy:",this.usersCopy);
				// console.log("this.itemsSearch:",this.itemsSearch);
				this.dialogUsersAdd = false;
				if(this.usersCopy.length>0){
					for (let i = 0; i < this.usersCopy.length; i++) {
						const prsID = this.usersCopy[i].PrsID;
						
						const exists = this.itemsSearch.some(item => item.PrsID == prsID);
						// console.log("exists:",exists);
						if (!exists) {
							const itemNew = {
								PrsID: prsID,
								UsrCreateID: this.$fun.getUserID(),
								NtpFullName: this.usersCopy[i].NtpFullName
							};
							this.itemsSearch.push(itemNew);
						}
					}
				}

				if(this.itemsSearch.length>0){
					for (var i = 0; i < this.itemsSearch.length; i++) {
						this.itemsSearch[i].UsrCreateID = this.$fun.getUserID();
					}
				}
				// console.log("this.itemsSearch:", this.itemsSearch);
			},
			addNewUsers(){
				this.dialogUsersAdd = true;
				this.usersCopy = [];
				// this.$refs.usrcopy.refresh();
			},
			AsgWorkerName(row){
				this.filterUser.TskID = row.TskID;
				this.itemSelectedSave = row;
				// if(row.itemsDetail != null){
				// 	row = JSON.parse(row.itemsDetail);
				// 	this.itemsSearch = row;	
				// }else{
				// 	this.itemsSearch = [];
				// }
				this.dialogUsers = true;
			},
			rowClickSearch: function(item, row) {
				// console.log("item Desde la tabla:",item);
				if (item !== undefined) {
					if(item == this.selectedSearch[0]){
						this.selectedSearch = [];
					}else{
						this.selectedSearch = [item];
					}
				}
			},
			clickProyect( proyect ){
				this.TkpStatus = proyect.TkpStatus;
				// console.log("this.TkpStatus", this.TkpStatus);
				this.proyect = proyect;
			  	this.filter.TkpID = proyect.TkpID;
				this.getTicTarget();
			},
			sendMail(task)
			{
				_sTaskService
				.sendmail(task, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200)
					{
						this.$fun.alert("Enviado correctamente", "success");
						return;
					}
				})
			},

			initialize()
			{
				this.loadDefinition();
				this.filterProjects(2);
				this.getTicWorkers();
				this.getTicProyects();
			},

			async save(item) {
				
				if (isUndefined(item.PrsID)) item.PrsID = this.filter.PrsID;
				item.AreID = this.filter.AreID;
				item.TkpID = this.filter.TkpID;
				if (item.SecStatus == null) item.SecStatus = 1;

				item.UsrCreateID = this.$fun.getUserID();
				item.FilePath = this.Attach1 != null ? this.Attach1.name : "";

				item.itemsDetail = [
					{
						UsrCreateID: this.$fun.getUserID(),
						PrsID: item.PrsID
					}
				];

				if (this.Attach1 instanceof File) {
                    
                    let files = [this.Attach1];
                    let formData = new FormData();

                    files.forEach((element, index) => {
                        formData.append(index.toString(), element);
                    });

                    _sGeneral.uploadfile("TicTask", this.$fun.getUserID(), formData, 3)
                        .then(response => {
                            if (response.status === 200) {
                                console.log("Archivo subido correctamente");
                            }
                        });
                }

				try {
					await new Promise((resolve, reject) => {
						if (typeof item.save === "function") {
							const result = item.save();
							if (result instanceof Promise) {
								result.then(resolve).catch(reject);
							} else {
								resolve(result);
							}
						} else {
							reject(new Error("item.save no es una función"));
						}
					});
					// console.log("saveeeeeeee");
				} catch (error) {
					console.error("Error al guardar el item:", error);
				}

				this.dialogTable = false;
				setTimeout(() => {
					this.dialogTable = true;
				}, 10);
			},
			openFile(nameFile) {
				_sGeneral.download(nameFile, this.$fun.getUserID()).then((r) => {
					if (r.status === 200) {
						// console.log("Imprime :", r);
						this.$fun.downloadHttp(r);
					}       
				});
			},
			FunAdd() {
				this.TkcID=0;
				this.SecStatus = 1;
				this.showInputField = !this.showInputField;
			},

			// Función para registrar la nueva condición
			registrarCondicion() {
				if (this.newConditionName) {
					
					let obj = {
						TkcID:this.TkcID,
						TskID:this.TksIDi,
						TkcName: this.newConditionName,
						SecStatus: this.SecStatus,
						UsrCreateID: this.$fun.getUserID(),
						TkcStatus: 0
					}
					_sTaskService.saveCondition(obj, this.$fun.getUserID())
					.then(resp => {
						if(resp.status == 200){
							this.$fun.alert("Accion realizada con exito", "success");
							this.showInputField = !this.showInputField;
							this.newConditionName='';
							this.getTicCondition(this.TksIDi);
						}
					});
				
				}
			},
			getTicWorkers()
			{
				let obj = {
					AreID: this.filter.AreID
				}
				_sTaskService
				.ticworkers(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						// console.log('work', resp.data)
						this.workerstic = resp.data;
					}
				})
			},
			getTicTarget()
			{
				let obj = {
					TkpID: this.filter.TkpID
				}
				_sTaskService
				.ticTargetbyProy(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						// console.log('target', resp.data)
						this.targetTic = resp.data;
					}
				})
			},
			CerrarModalCondition(){
				this.showInputField =false;
				this.modalCondition=false;
				this.page=1;
			},
			getTicCondition(TskID)
			{
				let obj = {
					TskID: TskID
				}
				_sTaskService
				.ticConditionByTask(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						// console.log('condiiton', resp.data)
						this.ConditionTic = resp.data;
						this.ConditionTic.forEach(condition => {
						condition.selected = condition.TkcStatus >0?true:false; // Si TkcID es 1, está seleccionado
						// console.log(condition.TkcStatus);
						});
					}
					
				});
			},
			getTictaskStaList()
			{
				let obj = {
					TskStatus: 2,
					UsrID: this.$fun.getUserID()
				}
				_sTaskService
				.tictaskBystatusTask(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						this.tictaStatusList = resp.data;
					}
				});
			},
            getTicSummary()
			{
				this.loadingData = true;
				let obj = {
					AreID: this.filter.AreID,
					DateBegin:this.BeginDate,
					DateEnd:this.EndDate
				}
				_sTaskService
				.ticketSummary(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						// console.log('sum', resp.data)
						this.summarytic = resp.data;
					}
					this.loadingData = false;
				})
			},
			getTicGeneralSummary()
			{
				let obj = {
					AreID: this.filter.AreID,
					DateBegin:this.BeginDate,
					DateEnd:this.EndDate
				}
				_sTaskService
				.ticketGeneralSummary(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						// console.log('sum', resp.data)
						this.Gensummarytic = resp.data;
					}
				})
			},
			downloadExcel(){
				console.log("Dataaaaaaaaaaaaaaa:",this.Gensummarytic);
				this.$fun.alert("¿Seguro de descargar?", "question")
				.then(r => {
					if(r.value){
						_sTaskService
						.convertexcel(this.Gensummarytic, this.$fun.getUserID())
						.then(resp => {
							this.$fun.downloadFile(resp.data, this.$const.TypeFile.EXCEL, this.$fun.getUserID());
						})
					}
				})
			},
            getTicProyects()
			{
				let obj = {
					AreID: this.filter.AreID,
					UsrID: this.$fun.getUserID(),
					TkpStatus: this.selectedFilter
				}
				_sTaskService
				.ticproyect(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						console.log('proyect', resp.data)
						this.Proyectic = resp.data;
					}
				});
			},
			saveSelected() {
				// Función para guardar las selecciones
				const selectedConditions = this.ConditionTic.filter(condition => condition.selected);
				const sconcatenatedString = selectedConditions.map(condition => condition.TkcID).join(", ");
				// console.log("aqui",sconcatenatedString); 
				const unselectedConditions = this.ConditionTic.filter(condition => !condition.selected);
				const uconcatenatedString = unselectedConditions.map(condition => condition.TkcID).join(", ");
				// console.log("Condiciones no seleccionadas:", uconcatenatedString);

				let obj = {
					TskID: this.TksIDi,
					SecStatus:1,
					UsrCreateID: this.$fun.getUserID(),
					TkcIDT: sconcatenatedString,
					TkcIDF: uconcatenatedString
				}
				_sTaskService
				.TicTaskConditionTask(obj, this.$fun.getUserID())
				.then(resp => {
					if(resp.status == 200){
						this.$fun.alert("Actualizado correctamente", "success");
						this.modalCondition=false;
					}
				});
			},
            clickConditionTask(item){
				this.newData = {};
				this.modalCondition = true;
				this.newData.TskID = item.TskID;
			},
			close(){
				this.newData={};
				this.modalCondition = false;
			},
			clickActionTask(item)
			{
				let message = ''
				let valueTasks = 0;
				if (item.TskStatus == 1)
				{
					message = '¿Seguro de iniciar?'
					item.TskDateBegin='1999-09-09 10:00:50.747';
					valueTasks = 2;
				}
				else
				{
					message = '¿Seguro de finalizar?'
					item.TskDateEnd='1999-09-09 10:00:50.747';
					valueTasks = 3;
				}

				this.$fun.alert(message, "question")
				.then(r => {
					if(r.value)
					{
						item.TskStatus = valueTasks;
						item.SecStatus = valueTasks ? 1 : item.SecStatus;
						item.UsrUpdateID = this.$fun.getUserID();
						_sTaskService
						.save(item, this.$fun.getUserID())
						.then(resp => {
							if(resp.status == 200)
							{
								if(item.TskStatus = 2){
									this.sendMail(item);
								}
								this.$fun.alert("Actualizado correctamente", "success");
								this.$refs.gridtask.refresh();  
							}
						})
					}
				})
				
			},
			clickPausedTask(item){
				this.$fun.alert(`¿Seguro de ${item.TskPaused == 1 ? "reanudar" : "pausar"}?`, "question")
				.then(r => {
					if(r.value)
					{
						item.TskPaused = item.TskPaused == 1 ? 0 : 1;
						item.TskStatus = item.TskPaused === 1 ? 6 : 2;
						item.PrsID = this.$fun.getUserInfo().PrsID;
						_sTaskService
						.save(item, this.$fun.getUserID())
						.then(resp => {
							if(resp.status == 200)
							{
								this.$fun.alert("Actualizado correctamente", "success");
								this.$refs.gridtask.refresh();  
							}
						})
					}
				})
				
			},
			TskHistory(item){
				this.dataHistory = {};
				this.dataHistory = item;
				this.OpenHistory = true;
			},
            opendialogResult(){
             	this.dialogResult = true;
			},
			opendialogTaskProceso(){
				this.dialogProccess = true; 
				this.getTictaskStaList();
			},
			pausedTask()
			{
				if(this.selected.TskStatus != 1 && this.selected.TskStatus != 2)
				{
					this.$fun.alert("La tarea ya fue finalizada o transferida", "info");
					return;
				}
				if(this.selected.TskPaused == 1)
				{
					this.$fun.alert("¿Seguro de reanudar tarea?", "question")
					.then(r => {
						if(r.value)
						{
							this.selected.TskStatus = 104;
							this.selected.UsrUpdateID = this.$fun.getUserID();
							_sTaskService
							.save(this.selected, this.$fun.getUserID())
							.then(resp => {
								if(resp.status == 200)
								{
									this.$fun.alert("Reanudada correctamente", "success");
									this.$refs.gridtask.refresh();
									this.dialogPaused = false;
									return;
								}
							})
						}
					})
					return;
				}
				if(this.selected.TskPaused == 0)
				{
					this.dialogPaused = true;
				}
				
			},

			cancelPausedTask()
			{
				this.dialogPaused = false;
			},
			restartFilter() {
				this.month = null;
				this.week = [];
				this.EndDate = this.$moment().add('days', -1).format("YYYY-MM-DD");
				this.BeginDate = this.$moment().format("YYYY-MM-DD");
            },

			sendPaused()
			{

				this.selected.TskStatus = 103;
				this.selected.UsrUpdateID = this.$fun.getUserID();
				this.selected.TskReasonTraslate = this.dataPaused.TskReasonTraslate;
				this.$fun.alert("¿Seguro de pausar?", "question")
				.then(r => {
					if(r.value)
					{
						_sTaskService
						.save(this.selected, this.$fun.getUserID())
						.then(resp => {
							if(resp.status == 200)
							{
								this.$fun.alert("Pausado correctamente", "success");
								this.$refs.gridtask.refresh();
								this.dialogPaused = false;
								return;
							}
						})
					}
				})
			},
            
			cancelTransferTask()
			{
				this.dialogTransfer = false;
			},

			sendTransfer()
			{
				if(this.selected.PrsID == this.datatransfer.PrsIDTraslate)
				{
					this.$fun.alert("No se puede trasladar a la misma persona", "info");
					return;
				}
				this.$fun.alert("¿Seguro de transferir?", "question")
				.then(r => {
					if(r.value)
					{
						this.selected.PrsIDTraslate = this.datatransfer.PrsIDTraslate;
						this.selected.TskReasonTraslate = this.datatransfer.TskReasonTraslate;
						this.selected.UsrUpdateID = this.$fun.getUserID();
						this.selected.TskStatus = 102
						
						_sTaskService
						.save(this.selected, this.$fun.getUserID())
						.then(resp => {
							if(resp.status == 200)
							{
								this.$fun.alert("Transferido correctamente", "success");
								this.$refs.gridtask.refresh();
								this.dialogTransfer = false;
							}
						})
					}
				})
				
			},

			rowSelected(items)
			{
				this.Attach1 = null;
				
				if(items.length > 0)
				{
					const selected = items[0];
                    this.selected = selected;

                    if (selected.FilePath) {
                        this.Attach1 = { name: selected.FilePath };
                    } else {
                        this.Attach1 = null;
                    }
				}
			},
			saveTaskUser(item){
				item.TskID = this.itemSelectedSave.TskID;
				item.UsrCreateID = this.$fun.getUserID();
				item.UsrUpdateID = this.$fun.getUserID();
				this.$fun.alert("Seguro de Guardar?", "question")
				.then(r => {
					if(r.value){
						_sTaskUsersService.save(item, this.$fun.getUserID())
							.then(resp => {
								if(resp.status == 200){
									this.$fun.alert("Se agrego correctamente", "success");
									this.$refs.ScrudTaskUsers.refresh();
								}
							});
					}
				});
			},
			TskTransfer(task) {
				this.selectedTask = task;
				this.currentProjectId = this.proyect.TkpID; // ID del proyecto actual
				this.selectedProjectIndex = null;
				this.loadAvailableProjects();
				this.transferDialog = true;
			},
			loadAvailableProjects() {
				// Usar la misma lista de proyectos que ya tienes
				this.availableProjects = this.Proyectic.filter(project => {
					// Opcional: filtrar proyectos según permisos o estado
					return project.TkpStatus !== 3; // No incluir proyectos cerrados
				});
			},
			async confirmTransfer() {
				if (!this.selectedProject || !this.selectedTask) {
					return;
				}
				
				this.$fun.alert("¿Seguro de transferir esta tarea a " + this.selectedProject.TkpTitle + "?", "question")
				.then(r => {
					if(r.value)
					{
						this.transferring = true;
						const transferData = {
							TskID: this.selectedTask.TskID,
							TkpID: this.selectedProject.TkpID,
							TskReasonTraslate: this.transferReason,
							PrsIDTraslate: this.$fun.getUserInfo().PrsID,
							UsrUpdateID: this.$fun.getUserID()
						};
						_sTaskService.transfer(transferData, this.$fun.getUserID())
						.then(resp => {
							if (resp.status == 200) {
								this.$fun.alert('Tarea ' + this.selectedTask.TskID + ' transferida correctamente al proyecto ' + this.selectedProject.TkpTitle, 'success');
								this.$refs.gridtask.refresh();
								this.transferDialog = false;
								this.transferring = false;
							}
						});

						this.transferDialog = false;
						this.transferring = false;
					}
				});
			},

			// Cancelar transferencia
			cancelTransfer() {
				this.transferDialog = false;
				this.selectedTask = null;
				this.selectedProjectIndex = null;
			},
		},

		created () {
			this.filter.AreID =  this.$fun.getUserInfo().CtrContract.AreID ?? 0;
			for (let i = 1; i <= 53; i++) {
            this.itemsWeek.push({
                text: i,
                value: i,
            });
            }
			this.years = this.$fun.getTop5LastYears();
			this.year = this.$moment().year();
			this.initialize();
		},
		mounted() {
			this.filter.PrsID =  this.$fun.getUserInfo().PrsID;
		}
	}
</script>

<style>
	.scrollable {
	max-height: 450px; /* Ajusta según sea necesario */
	overflow-y: auto;  /* Habilita el scroll vertical */
	}
	.bg-green{
		background-color: green;
	}
	.bordered-div {
	border: 1px solid grey; /* Borde negro de 2px */
	padding: 10px; /* Espaciado dentro del div */
	margin: 5px;
	border-radius: 5px; /* Esquinas redondeadas opcionales */
	}

</style>